import * as Sentry from "@sentry/react";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./assets/styles/main.css";
import App from "./App.tsx";
import "@/utils/numberExtensions.ts";

Sentry.init({
  dsn: "https://fb616bfea03525503f9825cd847c97d5@o4510856566538240.ingest.de.sentry.io/4510856595767376",
  sendDefaultPii: true,
  environment: import.meta.env.MODE,
  enabled: import.meta.env.MODE !== "development",
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
